import { render, staticRenderFns } from "./CPFundDetails.vue?vue&type=template&id=6199f716&scoped=true&"
import script from "./CPFundDetails.vue?vue&type=script&lang=ts&"
export * from "./CPFundDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CPFundDetails.vue?vue&type=style&index=0&id=6199f716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199f716",
  null
  
)

export default component.exports